import imagesLoaded from "imagesloaded";
import navigation from "./components/navigation";
import homeStats from "./components/homeStats";
import postsPagination from "./components/postsPagination";
import homeSlider from "./components/homeSlider";
import expandingForm from "./components/expandingForm";
import popup from "./components/popup";
import popupDownload from "./components/popupDownload";
import careerForm from "./components/careerForm";
import aosAnimations from "./components/aosAnimations";
import textVideoComponent from "./components/textVideoComponent";
import menu from "./components/menu";
import upcomingForm from "./components/upcomingForm";
import copyURLToClipboard from "./components/copyURLToClipboard";
import registrationForms from "./components/registration/forms";
import delayLoadRecaptcha from "./components/delayLoadRecaptcha";
import replaceLink from "./components/replaceLink";

navigation();
homeStats();
postsPagination();
var images = [...document.querySelectorAll(".js-home-slide img")];
var imgLoad = imagesLoaded(images);
imgLoad.on("done", homeSlider);
expandingForm();
popup();
careerForm();
aosAnimations();
textVideoComponent();
menu();
upcomingForm();
copyURLToClipboard();
popupDownload();
registrationForms();
replaceLink();

if (!document.body.classList.contains("page-template-home")) {
  // Load recaptcha on all pages except home
  delayLoadRecaptcha();
}
